"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENTS_VALIDATION = exports.INCLUDE_FLAG = void 0;
const regexp_1 = require("./regexp");
exports.INCLUDE_FLAG = 'included';
exports.DOCUMENTS_VALIDATION = new Map([
    [
        '6',
        {
            series: regexp_1.DIPLOMATIC_PASSPORT_SERIES_REG_EXP,
            number: regexp_1.DIPLOMATIC_PASSPORT_NUMBER_REG_EXP,
        },
    ],
    [
        '7',
        {
            series: regexp_1.FOREIGN_PASSPORT_SERIES_REG_EXP,
            number: regexp_1.FOREIGN_PASSPORT_NUMBER_REG_EXP,
        },
    ],
    [
        '9',
        {
            series: regexp_1.RESIDENCE_PERMIT_SERIES_REG_EXP,
            number: regexp_1.RESIDENCE_PERMIT_NUMBER_REG_EXP,
        },
    ],
    [
        '10',
        {
            series: regexp_1.REFUGEE_IDENTITY_SERIES_REG_EXP,
            number: regexp_1.REFUGEE_IDENTITY_NUMBER_REG_EXP,
        },
    ],
    [
        '11',
        {
            series: regexp_1.TEMPORARY_IDENTITY_SERIES_REG_EXP,
            number: regexp_1.TEMPORARY_IDENTITY_NUMBER_REG_EXP,
        },
    ],
    ['12', { series: exports.INCLUDE_FLAG, number: regexp_1.PASSPORT_REG_EXP }],
    [
        '15',
        {
            series: regexp_1.SEAFARER_PASSPORT_SERIES_REG_EXP,
            number: regexp_1.SEAFARER_PASSPORT_NUMBER_REG_EXP,
        },
    ],
    ['20', { series: exports.INCLUDE_FLAG, number: regexp_1.LICENSE_REG_EXP }],
    [
        '22',
        {
            series: regexp_1.FOREIGN_LICENSE_SERIES_REG_EXP,
            number: regexp_1.FOREIGN_LICENSE_NUMBER_REG_EXP,
        },
    ],
    [
        '1',
        {
            series: regexp_1.BIRTH_CERTIFICATE_SERIES_REG_EXP,
            number: regexp_1.BIRTH_CERTIFICATE_NUMBER_REG_EXP,
        },
    ],
]);
